import axios, { AxiosResponse, AxiosError, InternalAxiosRequestConfig } from 'axios';

// const API_BASE_URL: string = process.env.REACT_APP_API_URL || 'https://api.dev.bneinoach.org.br';
const API_BASE_URL: string = process.env.REACT_APP_API_URL || 'http://localhost:8000';


interface BnData {
  access_token: string;
  refresh_token: string;
  [key: string]: any;
}

class BaseService {
  private API: string;

  constructor() {
    this.API = API_BASE_URL;
    this.setupAxios();
  }

  private setupAxios(): void {
    // Request interceptor
    axios.interceptors.request.use(
      (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
        const token = this.getToken();
        if (token && config.headers) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error: AxiosError): Promise<AxiosError> => {
        return Promise.reject(error);
      }
    );

    // Response interceptor
    axios.interceptors.response.use(
      (response: AxiosResponse): AxiosResponse => {
        return response;
      },
      (error: AxiosError): Promise<AxiosError> => {
        if (error.response?.status === 401) {
          // Handle unauthorized access
          localStorage.removeItem('bn');
          window.location.href = '/identificacao';
        }
        return Promise.reject(error);
      }
    );
  }

  public getToken(): string | null {
    const bnString = localStorage.getItem('bn');
    if (!bnString) {
      return null;
    }
    try {
      const bn: BnData = JSON.parse(atob(bnString));
      return bn.access_token;
    } catch (error) {
      return null;
    }
  }

  public getRefreshToken(): string | null {
    const bnString = localStorage.getItem('bn');
    if (!bnString) {
      return null;
    }
    try {
      const bn: BnData = JSON.parse(atob(bnString));
      return bn.refresh_token;
    } catch (error) {
      return null;
    }
  }

  public getApiUrl(): string {
    return this.API;
  }
}

export default BaseService; 